import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import moment from 'moment';

import client from '../../../utils/apolloClient';

import Layout from '../../../components/global/Layout';
import Header from './Header';
import EventList from './EventList';
import SearchBox from './SearchBox';
import { Box, Table, Loading, Pagination } from '../../../components/elements';

const EventsQuery = gql`
  query searchEvents($input: SearchInput) {
    search_events(input: $input) {
      total_pages
      total_size
      event_listing {
        place_id
        event_id
        status
        display_order
        featured
        default_url
        start
        end
        place_name
        venue_name
        name
        description
        tagline
        slug
        listing_type
        voucher_count
        minimum_price
        maximum_price
        address_line_1
        address_line_2
        city
        state
        country
        post_code
        latitude
        longitude
        location
        timezone
        audit {
          updated_at
          updated_by
        }
      }
    }
  }
`;

const usersQuery = gql`
  query searchUsers($input: SearchInput) {
    search_users(input: $input) {
      user_listing {
        user_id
        display_name
        first_name
        last_name
        full_name
        email
      }
    }
  }
`;

const ManageEvents = () => {
  const [eventData, setEventData] = useState([]);
  const [sort, setSort] = useState('UPDATED_DESC');
  const [eventNameSort, setEventNameSort] = useState('AES');
  const [businessNameSort, setBusinessNameSort] = useState('AES');
  const [citySort, setCitySort] = useState('AES');
  const [listingTypeSort, setListingTypeSort] = useState('AES');
  const [startDateSort, setStartDateSort] = useState('START_ASC');
  const [updatedAtSort, setUpdatedAtSort] = useState('AES');
  const [updatedBySort, setUpdatedBySort] = useState('AES');

  const [listing_type] = useState('public_tickets');
  const [status, setStatus] = useState('current');
  const [eventStatus, setEventStatus] = useState('ACTIVE');

  const [searchQuery, setSearchQuery] = useState('');
  const [eventNameSearchQuery, setEventNameSearchQuery] = useState('');
  const [placeNameSearchInput, setPlaceNameSearchInput] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [pageFrom, setPageFrom] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [listSize] = useState(10);
  const [location, setLocation] = useState('');

  const [totalElements, setTotalElements] = useState();

  const [startDateRangeFilter, setStartDateRangeFilter] = useState({
    end_date: moment().format('YYYY-MM-DD'),
  });
  const [endDateRangeFilter, setEndDateRangeFilter] = useState({
    start_date: moment().format('YYYY-MM-DD'),
  });

  const input = {};
  const event_filter = { listing_type, draft: false };
  //  console.log('searchCity', searchCity);
  Object.assign(input, searchCity !== '' && { location: searchCity });
  Object.assign(
    event_filter,
    { status: eventStatus },
    placeNameSearchInput !== '' && { place_name: placeNameSearchInput },
    eventNameSearchQuery !== '' && { event_name: eventNameSearchQuery },
    startDateRangeFilter && {
      start_date_range: startDateRangeFilter,
    },
    endDateRangeFilter && {
      end_date_range: endDateRangeFilter,
    },
  );
  Object.assign(
    input,
    location !== '' && { location },
    { from: pageFrom, size: listSize },
    { sort },
    searchCity !== '' && { location: searchQuery },
    searchQuery !== '' && { search_criteria: searchQuery },
    event_filter !== {} && {
      filter: {
        event_filter,
      },
    },
  );
  const [statusFilter, setStatusFilter] = useState('ACTIVE');
  return (
    <Layout>
      <Header />
      <Box>
        <SearchBox
          eventStatus={eventStatus}
          setEventStatus={setEventStatus}
          searchQuery={searchQuery}
          eventNameSearchQuery={eventNameSearchQuery}
          setEventNameSearchQuery={setEventNameSearchQuery}
          status={status}
          setStatus={setStatus}
          setLocation={setLocation}
          handleSearchTag={setSearchQuery}
          handleLocation={setSearchCity}
          setStartDateRangeFilter={setStartDateRangeFilter}
          setEndDateRangeFilter={setEndDateRangeFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          placeNameSearchInput={placeNameSearchInput}
          setPlaceNameSearchInput={setPlaceNameSearchInput}
        />
        {totalElements > 0 && (
          <Pagination
            pageFrom={pageFrom}
            pageCount={pageCount}
            listSize={listSize}
            totalElements={totalElements}
            currentPage={currentPage}
            handlePageClick={value => {
              setPageFrom(value.selected * listSize);
              setCurrentPage(value.selected + 1);
            }}
          />
        )}

        <Table>
          <thead>
            <tr>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setEventNameSort(
                          eventNameSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          eventNameSort === 'AES'
                            ? 'EVENT_NAME_DESC'
                            : 'EVENT_NAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          eventNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Event Name
                  </span>
                  {/* <br />
            <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setBusinessNameSort(
                          businessNameSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          businessNameSort === 'AES'
                            ? 'PLACE_NAME_DESC'
                            : 'PLACE_NAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          businessNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Place Name
                  </span>
                  {/* <br />
            <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setCitySort(citySort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          citySort === 'AES'
                            ? 'PLACE_CITY_DESC'
                            : 'PLACE_CITY_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          citySort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    City / Suburb
                  </span>
                  {/* <br />
            <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setListingTypeSort(
                          listingTypeSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          listingTypeSort === 'AES'
                            ? 'LISTING_TYPE_DESC'
                            : 'LISTING_TYPE_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          listingTypeSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    Listing Type
                  </span>
                  {/* <br />
            <CustomSelect
              options={[
                { value: '', label: 'Select..' },
                { value: 'APPROVED', label: 'APPROVED' },
                { value: 'UNAPPROVED', label: 'UNAPPROVED' },
              ]}
            /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setStartDateSort(
                          startDateSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          startDateSort === 'AES' ? 'START_DESC' : 'START_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          startDateSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    Start Date
                  </span>
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setUpdatedBySort(
                          updatedBySort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          updatedBySort === 'AES'
                            ? 'CREATED_DESC'
                            : 'CREATED_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          updatedBySort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Updated By
                  </span>
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setUpdatedAtSort(
                          updatedAtSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          updatedAtSort === 'AES'
                            ? 'UPDATED_DESC'
                            : 'UPDATED_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          updatedAtSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    Updated At
                  </span>
                </div>
              </th>
              {/* <th>
                <div>
                  <span>
                    <i className="fas fa-sort-amount-down" /> Status
                  </span>
                  <br />
                  <CustomSelect
              options={[
                { value: '', label: 'Select..' },
                { value: 'APPROVED', label: 'APPROVED' },
                { value: 'UNAPPROVED', label: 'UNAPPROVED' },
              ]}
            />
                </div>
              </th> */}
            </tr>
          </thead>
          {/* <tbody>
            <Elements data={data} loading={loading} error={error} />
          </tbody> */}

          <Query
            query={EventsQuery}
            variables={{ input }}
            fetchPolicy="network-only"
          >
            {({ data, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return 'error';
              }
              const { search_events } = data;

              if (search_events.event_listing.length === 0) {
                return 'NO RECORDS FOUND';
              }
              return (
                <React.Fragment>
                  <View
                    eventData={eventData}
                    setEventData={setEventData}
                    search_events={search_events}
                    setPageCount={setPageCount}
                    setTotalElements={setTotalElements}
                  />
                </React.Fragment>
              );
            }}
          </Query>
        </Table>
      </Box>
    </Layout>
  );
};

export default ManageEvents;

const View = ({
  search_events,
  setPageCount,
  setTotalElements,
  eventData,
  setEventData,
}) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    setPageCount(search_events.total_pages);
    setTotalElements(search_events.total_size);
    if (search_events.event_listing) {
      setEventData(search_events.event_listing);

      const userFilter = search_events.event_listing.map(
        item => item.audit.updated_by,
      );

      client.clientPrivate
        .query({
          query: usersQuery,
          variables: {
            input: { filter: { user_filter: { user_id: userFilter } } },
          },
        })
        .then(({ data: { search_users } }) => {
          console.log('result');
          if (search_users) {
            setUsers(search_users.user_listing);
          }
        });
    }
  }, [search_events.total_pages]);
  return (
    <tbody>
      {eventData &&
        eventData.map(events => (
          <tr key={events.event_id}>
            <EventList events={events} users={users} />
          </tr>
        ))}
    </tbody>
  );
};
